import { useState, useEffect, useRef } from "react";
import { jwtFetch } from "./utils/apiClient";
import { sortTableRows } from "./utils/tableSort";
import { config, encodeBase64RequestBody } from "./Components/Config";
import Menu from "./Components/Menu";
import Header from "./Components/Header";

const Client = () => {
  const [companies, setCompanies] = useState(null);
  const [tableSearch, setTableSearch] = useState('');
  const [tableSortBy, setTableSortBy] = useState('company_name');
  const [tableSortType, setTableSortType] = useState('ascending');
  const [isLoadingPage, setIsLoadingPage] = useState(true);
  const searchInputRef = useRef(null);
  const crmUser = JSON.parse(localStorage.getItem('crmUser'));


  useEffect(() => {
    getCompanies();
  }, []);

  const getCompanies = async () => {
    try {
      const requestCompanies = {}
      const fetchCompanies = await jwtFetch(config.ENDPOINT + 'get/company', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: encodeBase64RequestBody(requestCompanies)
      });
      const responseCompanies = await fetchCompanies.json();
      if (responseCompanies.status === 200) {
        for (let i in responseCompanies.data) {
          let searchData = (responseCompanies.data[i].company_name || '').toLowerCase();
          searchData += (responseCompanies.data[i].company_domain || '').toLowerCase();
          searchData += (responseCompanies.data[i].company_billing_name || '').toLowerCase();
          searchData += responseCompanies.data[i].subcompany_names ? responseCompanies.data[i].subcompany_names.toLowerCase() : '';
          responseCompanies.data[i].search = searchData;
        }
        setCompanies(responseCompanies.data);
        setIsLoadingPage(false);
      } else {
        alert(responseCompanies.message);
      }
    } catch (error) {
      console.error('Error in getCompanies:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  }

  const sortTable = (sortBy) => {
    if (tableSortBy === sortBy) {
      setTableSortType(tableSortType === 'ascending' ? 'descending' : 'ascending');
    } else {
      setTableSortBy(sortBy);
      setTableSortType('ascending');
    }
  }

  const clearSearch = () => {
    setTableSearch('');
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }

  return (
    <div id="client-list">
      <div className="container-fluid p-0">
        <div className="row g-0 mh-100vh">
          <div className="col-md-2 border-end">
            <div className="d-md-flex d-none align-items-center justify-content-center p-1 h-48">
              <a className="h-100" href="/dashboard"><img className="h-100" src="/cuancuan.png" alt="PointStar" /></a>
            </div>
            <hr className="m-0" />
            <Menu active="client" />
          </div>
          <div className="col-md-10">
            <Header />
            <hr className="m-0" />
            <div className="main">
              <div className="p-4">

                <section className="mb-4">
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div className="d-flex align-items-center justify-content-between gap-4">
                      <div className="fs-24">Client List</div>
                      <div className="btn-group" role="group">
                        <button className="btn bg-gold" type="button"><i className="bi bi-building me-1" /> Company Groups</button>
                        <button className="btn btn-secondary" type="button" onClick={() => window.location.href = '/client/subsidiary'}><i className="bi bi-buildings me-1" /> Subsidiaries</button>
                        <button className="btn btn-secondary" type="button" onClick={() => window.location.href = '/client/contact'}><i className="bi bi-people me-1" /> Contacts</button>
                      </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-between gap-2">
                      <div className="input-group input-search">
                        <button className="btn bg-white" type="button" onClick={() => clearSearch()}>{tableSearch ? <i className="bi bi-x-lg" /> : <i className="bi bi-search" />}</button>
                        <input className="form-control" type="text" placeholder="Search" value={tableSearch} onChange={(e) => setTableSearch(e.target.value)} ref={searchInputRef} autoFocus />
                      </div>
                      {(crmUser.user_department !== 'Sales Admin' && crmUser.user_level !== 'View') && (
                        <button className="btn btn-link bg-gold" type="button" onClick={() => window.location.href = '/client/add'}><i className="bi bi-plus-circle me-1" /> Add</button>
                      )}
                    </div>
                  </div>
                  <div className="bg-white border-radius-4 p-4">
                    {companies && companies.length ? (
                      <div className="table-responsive">
                        <table className="table table-hover">
                          <thead>
                            <tr>
                              <th className="bg-gold">#</th>
                              <th className="bg-gold pointer text-start" onClick={() => sortTable('company_name')}>Group Name {tableSortBy === 'company_name' && (tableSortType === 'ascending' ? <span className="bi bi-sort-down-alt ms-2" /> : <span className="bi bi-sort-up-alt ms-2" />)}</th>
                              <th className="bg-gold pointer text-start" onClick={() => sortTable('company_billing_name')}>Legal Name {tableSortBy === 'company_billing_name' && (tableSortType === 'ascending' ? <span className="bi bi-sort-down-alt ms-2" /> : <span className="bi bi-sort-up-alt ms-2" />)}</th>
                              <th className="bg-gold pointer text-start" onClick={() => sortTable('company_domain')}>Domain {tableSortBy === 'company_domain' && (tableSortType === 'ascending' ? <span className="bi bi-sort-down-alt ms-2" /> : <span className="bi bi-sort-up-alt ms-2" />)}</th>
                              <th className="bg-gold pointer text-center" onClick={() => sortTable('subcompanies')}>Subsidiaries {tableSortBy === 'subcompanies' && (tableSortType === 'ascending' ? <span className="bi bi-sort-down-alt ms-2" /> : <span className="bi bi-sort-up-alt ms-2" />)}</th>
                              <th className="bg-gold pointer text-center" onClick={() => sortTable('company_status')}>Status {tableSortBy === 'company_status' && (tableSortType === 'ascending' ? <span className="bi bi-sort-down-alt ms-2" /> : <span className="bi bi-sort-up-alt ms-2" />)}</th>
                              <th className="bg-gold"></th>
                            </tr>
                          </thead>
                          <tbody>
                            {sortTableRows(companies, tableSortBy, tableSortType === 'ascending')
                              .filter(company => tableSearch === '' || company.search.toLowerCase().includes(tableSearch.toLowerCase()))
                              .map((company, c) =>
                                <tr key={"company-" + c}>
                                  <td valign="middle">{c + 1}</td>
                                  <td valign="middle">{company.company_name}</td>
                                  <td valign="middle">{company.company_billing_name}</td>
                                  <td valign="middle">{company.company_domain}</td>
                                  <td valign="middle" align="center" title={company.subcompany_names}>{company.subcompanies}</td>
                                  <td valign="middle" align="center"><span className={"badge bg-" + (company.company_status === 'Active' ? 'success' : 'danger')}>{company.company_status}</span></td>
                                  <td valign="middle" align="right"><button className="btn btn-sm bg-gold" onClick={() => window.location.href = '/client/detail/' + company.id_company}><i className="bi bi-eye" /></button></td>
                                </tr>
                              )}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <p>{isLoadingPage ? 'Loading...' : 'No data'}</p>
                    )}
                  </div>
                </section>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Client;
